<template>
  
  <div>
    <p class='title is-1'>explore</p>
    <div class='myTile'>
      <p class='title is-3 is-6-mobile'>search for a specific user</p>
      <div class='has-text-left'>
        <p>Want to see how you did? Search for a specific user to get their infection stats.</p>
        <br>
        <form @submit.prevent="getAWS">
          <div class='columns'>
            <div class='column is-8'>
              <input class='input' type='text' v-model="searchedUser" placeholder='woodendoors7' v-on:submit="getAWS">
            </div>
            <div class='column'>
              <button type="submit" class='button is-fullwidth is-danger' :disabled="!validUser" :class="{'is-loading': searching}">search</button>
            </div>
          </div>
        </form>
        
        <p class='hint'>searches are case sensitive</p>
        <br>

        <!-- SEARCH RESULTS -->
        <div v-show="searchLoaded">
          <div v-if="searchData.infectorUser === undefined">
            <p><span class='userName'>{{ searchData.infecteeUser }}</span> was not found in the infection database. Either they did not contract the virus or you provided an invalid username.</p>
          </div>

          <div v-else> 
            <div v-if="searchData.infecteeUser === 'woodendoors7'">
              <p><span class='userName'>{{ searchData.infecteeUser }}</span> was patient zero.</p>
            </div>

            <div v-else>
              <p><span class='userName'>{{ searchData.infecteeUser }}</span> was infected on <span class='myNumber'>{{ searchData.infectionDate }}</span> at <span class='myNumber'>{{ searchData.infectionTime }}</span> by <span class='myNumber'>{{ infectionCauseText }}</span> from <span class='userName'>{{ searchData.infectorUser }}</span>.</p>                    
            </div>
          
            <br>
            <p><span class='userName'>{{ searchData.infecteeUser }}</span> spread the virus to <span class='myNumber'>{{ searchData.directInfections }}</span> other users and was responsible for a chain of <span class='myNumber'>{{ searchData.chainInfections }}</span> total infections.</p>

          </div>

        </div>

      </div>
    </div>
  </div>
</template>


<script>
  
  export default {
    data() {
      return {
        searchedUser: null,
        searchData: {},
        searchLoaded: false,
        searching: false,
      }
    },
    computed: {
      validUser() {
        return (this.searchedUser != null) && (this.searchedUser.trim().length > 0) 
      },
      infectionCauseText() {
        let text = ''
        let cause = this.searchData.infectionCause;
        if (cause === 'S') {
          text = 'commenting on an infected post'
        } else if (cause === 'C') {
          text = 'replying to a comment'
        }
        return text;
      }
    },
    methods: {
      getAWS() {
        let user = this.searchedUser.replace(/\s/g, '');

        // error catch
        if (!this.validUser) {
          return
        }

        this.searching = true;
        this.searchLoaded = false;
        this.searchData = {'infecteeUser': user}

        const DynamoDB = require('aws-sdk/clients/dynamodb')
        var docClient = new DynamoDB.DocumentClient({
          region: "us-east-1",
          accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID,
          secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY
        });
        var params = {
            TableName: 'r-memovirus',
            Key:{"infecteeUser": user}
        };

        const vm = this;
        docClient.get(params, function(err, data) {
            if (err) {
                console.error("Unable to read item. Error JSON:", JSON.stringify(err, null, 2));
            } else {
                vm.searchData = Object.keys(data).length === 0 ? vm.searchData : data['Item']
            }
            vm.searchLoaded = true;
            vm.searching = false;
        });
      }
    },
  }

</script>

<style>
.hint {
  opacity: .33;
  font-style:  italic;
}
</style>
